import { supabase } from '../lib/supabase';

function uniqueSorted(names: string[]): string[] {
  return [...new Set(names.map((n) => n.trim()).filter(Boolean))].sort((a, b) =>
    a.localeCompare(b, 'tr')
  );
}

/** Aktif yazılım kataloğu; tablo boşsa forumlardaki benzersiz değerler */
export async function fetchSoftwareOptions(): Promise<string[]> {
  const { data, error } = await supabase
    .from('software')
    .select('name')
    .eq('is_active', true)
    .order('name');

  if (error) throw error;

  const fromCatalog = uniqueSorted((data || []).map((row) => row.name));
  if (fromCatalog.length > 0) return fromCatalog;

  const { data: forums, error: forumsError } = await supabase
    .from('forums')
    .select('software')
    .eq('is_active', true)
    .not('software', 'is', null);

  if (forumsError) throw forumsError;
  return uniqueSorted((forums || []).map((f) => f.software as string));
}
